import { Button, Card, Modal, Row } from "antd";
import React, { CSSProperties, useState } from "react";
import { Account, ApiCode } from "../../../data/common";
import { AppEvent, AppMessageType } from "../../../data/events";
import Api from "../../../utils/Api";
import events, { useEventBus } from "../../../utils/events";
import { UserInfoManager } from "../../../utils/UserInfoManager";
import AccountHideListView from "./account/AccountHideListView";
import AccountListView from "./account/AccountListView";
import AddAccountView from "./account/AddAccountView";
import { StyleUtils } from "../../../utils/Style";
import { GlobalUtil } from "../../../utils/GlobalText";
import DeleteAccountView from "./account/DeleteAccountView";
const { confirm } = Modal;
interface TabProps {
    label: string;
    selected: boolean;
    onClick: () => void;
    style?: CSSProperties
}

const Tab = ({ label, selected, onClick, style }: TabProps) => {

    return (
        <div
            onClick={onClick}
            style={{
                padding: '4px 12px',
                background: selected ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_bg_color,
                border: `1px solid ${selected ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_normal_border_color}`,
                borderRadius: "8px",
                cursor: "pointer",
                color: StyleUtils.theme().fontColor_1,
                fontWeight: "500",
                fontSize: "0.88rem",
                ...style
            }}
        >
            {label}
        </div>
    );
};

const AccountView = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectAccount, setSelectAccount] = useState<Account[]>([]);

    const tabData = [
        {
            "label": GlobalUtil.t("account.normalAccount"),
            "element": <AccountListView onSelectChange={(selects) => {
                setSelectAccount(selects)
            }} />
        },
        {
            "label": GlobalUtil.t("account.hiddenAccount"),
            "element": <AccountHideListView onSelectChange={(selects) => {
                setSelectAccount(selects)
            }} />
        }
    ]
    const handleTabClick = (tabIndex: number) => {
        setSelectAccount([])
        setSelectedTab(tabIndex);
    };
    const [openAddAccount, setOpenAddAccount] = useState(false)
    const [openDeleteAccount, setOpenDeleteAccount] = useState(false)
    const [deleteAccount, setDeleteAccount] = useState("")

    const setAccountHide = async (accounts: string, hide: Boolean) => {
        try {
            let res = await Api.hideAccount(accounts, hide)
            if (res.code === ApiCode.SUCCESS) {
                setSelectAccount([])
                UserInfoManager.getAccountInfoWithHashrate()
                UserInfoManager.getAccountInfo()
            } else {
                events.emit(AppEvent.SHOW_MESSAGE, {
                    type: AppMessageType.ERROR,
                    message: GlobalUtil.t("errorTip")
                })
            }
        } catch (e) {
            events.emit(AppEvent.SHOW_MESSAGE, {
                type: AppMessageType.ERROR,
                message: GlobalUtil.t("errorTip")
            })
        }
    }
    useEventBus(AppEvent.HIDE_ACCOUNT, (hideAccounts) => {
        setAccountHide(hideAccounts, true)
    })
    useEventBus(AppEvent.UNHIDE_ACCOUNT, (hideAccounts) => {
        setAccountHide(hideAccounts, false)
    })
    useEventBus(AppEvent.DELETE_SUB_ACCOUNT, (account) => {
        if (!UserInfoManager.mainAccount?.isTwofactorOpen) {
            events.emit(AppEvent.SHOW_TIP_DOUBLE_CHECC)
        } else {
            setDeleteAccount(account)
            setOpenDeleteAccount(true)
        }

    })
    const getSelectAccounts = (): string => {
        let accounts = ""
        selectAccount.forEach(v => {
            if (accounts.length) {
                accounts += ","
            }
            accounts += v.account
        })
        return accounts
    }
    const hideOrUnHideAccounts = async () => {
        setAccountHide(getSelectAccounts(), selectedTab === 0)
    }

    return (
        <div style={{ background: StyleUtils.theme().boardBg, paddingTop: "1rem", width: "100%" }}>
            {AddAccountView(openAddAccount, (ok) => {
                if (ok) {
                    UserInfoManager.getAccountInfoWithHashrate()
                    UserInfoManager.getAccountInfo()
                }
                setOpenAddAccount(false)
                return
            })}
            {
                <DeleteAccountView show={openDeleteAccount} account={deleteAccount} onClick={() => {
                    setDeleteAccount("")
                    setOpenDeleteAccount(false)
                }} />
            }

            <Row justify={"space-between"} style={{gap:'.5rem'}}>
                <div style={{ display: "flex",columnGap:'.5rem', background: StyleUtils.theme().mainColor, borderRadius: "8px" }}>
                    {
                        tabData.flatMap((item, index) => {
                            return <Tab
                                label={item.label}
                                selected={selectedTab === index}
                                onClick={() => handleTabClick(index)}
                            />
                        })
                    }
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                    <div onClick={() => { if (selectAccount.length) hideOrUnHideAccounts() }}
                        style={{
                            padding: "4px 12px",
                            background: selectAccount.length ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_bg_color,
                            border: `1px solid ${selectAccount.length ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_normal_border_color}`,
                            borderRadius: "8px",
                            cursor: "pointer",
                            color: StyleUtils.theme().fontColor_1,
                            fontWeight: "500",
                            fontSize: "0.88rem",
                            opacity: selectAccount.length ? 1 : 0.6
                        }}>
                        {selectedTab === 0 ? GlobalUtil.t("account.hidden") : GlobalUtil.t("account.noHidden")}
                    </div>
                    <div onClick={() => {
                        if (selectAccount.length) {
                            if (!UserInfoManager.mainAccount?.isTwofactorOpen) {
                                events.emit(AppEvent.SHOW_TIP_DOUBLE_CHECC)
                            } else {
                                setDeleteAccount(getSelectAccounts())
                                setOpenDeleteAccount(true)
                            }
                        }
                    }}
                        style={{
                            padding: "4px 12px",
                            background: selectAccount.length ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_bg_color,
                            border: `1px solid ${selectAccount.length ? StyleUtils.theme().work_group_border_color : StyleUtils.theme().work_group_normal_border_color}`,
                            borderRadius: "8px",
                            cursor: "pointer",
                            color: StyleUtils.theme().fontColor_1,
                            fontWeight: "500",
                            fontSize: "0.88rem",
                            opacity: selectAccount.length ? 1 : 0.6
                        }}>
                        {GlobalUtil.t("delete")}
                    </div>
                    <div onClick={() => { setOpenAddAccount(true) }}
                        style={{
                            padding: "4px 12px",
                            background: StyleUtils.theme().work_group_border_color,
                            border: `1px solid ${StyleUtils.theme().work_group_border_color}`,
                            borderRadius: "8px",
                            cursor: "pointer",
                            color: StyleUtils.theme().fontColor_1,
                            fontWeight: "500",
                            fontSize: "0.88rem"
                        }}>
                        {GlobalUtil.t("add")}
                    </div>
                    {/* {selectedTab === 0 && <Button style={buttonStyle}>排序</Button>} */}
                </div>

            </Row>
            <div style={{ marginTop: "0px", width: "100%" }}>
                {
                    tabData.filter((item, index) => {
                        return index === selectedTab
                    })[0].element
                }
            </div>
        </div>
    );
};

export default AccountView;
